import React from "react";

export const Price = ({ currency, price }) => {
  return (
    <span>
      {currency || "N/A"} {price ? Number(price).toFixed(2) : "N/A"}
    </span>
  );
};
